import { getAmplitudeInstance } from '../amplitudeHelpers';

/**
 * User dismisses the getting started welcome screen (tap X, swipe down, or system back).
 */
const logPostSignUpScreenDismissed = (callback?: () => void) => {
  getAmplitudeInstance().logEvent('post sign up screen dismissed', {}, callback);
};

export default logPostSignUpScreenDismissed;
